<template>
  <div id="notification-wrapper">
    <DxDropDownButton id="notification-button"
                      icon="message"
                      :items="visibleNotifications || []"
                      drop-down-content-template="notification-dropdown"
                      :drop-down-options="{ width: 'auto' }"
                      styling-mode="text"
                      display-expr="text"
                      @item-click="executeItemMethod"
    >
      <template #notification-dropdown="{ data }">
        <NotificationDropdown :notifications="visibleNotifications"/>
      </template>
    </DxDropDownButton>
    <NotificationMarker id="notification-marker" v-if="visibleNotifications.length > 0"/>
  </div>
</template>

<script setup>
  import NotificationMarker from "@/components/base-components/header/NotificationMarker.vue";
  import NotificationDropdown from "@/components/base-components/header/NotificationDropdown.vue";
  import DxDropDownButton from "devextreme-vue/drop-down-button";
  import { computed } from "vue";
  import { storeToRefs } from "pinia";
  import { useHeaderStore } from "@/stores/headerStore.js";

  const headerStore = useHeaderStore()
  const { notifications } = storeToRefs(headerStore)

  const visibleNotifications = computed(() => {
    if (!notifications) return []
    return notifications.value.filter(notification => notification.viewed === false)
  })
  const executeItemMethod = () => {}
</script>

<style lang="scss">
  #notification-wrapper {
    position: relative;
    margin: 0.5rem;
  }

  #notification-button {
    .dx-button-content {
      padding: 0;
    }

    .dx-icon-spindown {
      display: none;
    }
  }

  #notification-marker {
    position: absolute;
    bottom: -1px;
    right: -4px;
  }

  #notification-header {
    .dx-icon-clear {
      font-size: 11pt;
    }
  }
</style>
